export abstract class IUserSwitchCustomerDialogService {

  abstract userSwitchCustomerDialogShow(
    callbackCancel: () => void,
  ): void;

}
